import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';

const Collaborations = () => {
  useEffect(() => {
    
  
  }, [])
  
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Collaborations</h1>
        <h3>Cure disease - Secure generations!</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Collaborations
            </div>
              <Scrollspy
              className="scrollspy" items={['Waterloo', 'HongKong', 'Mexico', 'Taiwan','Indian']}
                currentClassName="active">
              <li><a href="#Waterloo">University of Waterloo</a></li>
              <li><a href="#HongKong">Hong Kong University of Science and Technology</a></li>
              <li><a href="#Mexico">Chihuahua Institute of Technology, Mexico </a></li>
              <li><a href="#Taiwan">National Tsing Hua University, Taiwan (August)</a></li>
              <li><a href="#Indian">Indian Institute of Science Education and Research Bhopal, India</a></li>
              
              </Scrollspy>
              
          </div>

        </div>
        <div className="main_lab_style Collaborations_page">
          <>
            <p id="Collaborations">
              <h1>
                Collaborations
                <br />
              </h1>
            </p>
            <section id="Waterloo">

            <p>
                <h4>University of Waterloo, Canada (23rd July 9 pm)</h4>
            </p>
              <ul>
                <li>[Zoom meeting]</li>
                <li>Discussed team structure, project details and goals</li>
              </ul>
            <p>Our first-ever 2022 iGEM collaboration meeting was with the<strong><em> University of Waterloo iGEM Team - Waterloo iGEM</em></strong> - <u>through zoom.</u> We spoke with their members to learn about how international teams approach the competition and the differences in methods of team operation, such as how the Waterloo iGEM team comprised over 50 members from diverse backgrounds of majors and the delegation of tasks amongst so many members. We prepared a short presentation to introduce our project concept to their team, followed by our future plans and discussed elements that our projects shared in common <u>with feedback on the approach each team had taken and possible implementation suggestions.</u> We then moved on to discuss potential collaboration activities that our teams could organise, such as grouping iGEM teams with similar project concepts to create a platform for mass feedback exchange for the betterment of each team's plans.</p>
              
              <br />
              <br />

              
              
              </section>


              <br />
              <br />
            <section id="HongKong">
              

              <p>
                <h4>Hong Kong University of Science and Technology, Hong Kong (13th August)</h4>

              </p>

              <ul>
                <li>Symposium</li>
                <li> <a href="https://youtu.be/YeL8s4tyjv4"> Vlog + Interview of (UST, HKU, CUHK, WYY)</a></li>
              </ul>

              <p><strong><em>The Hong Kong University of Science and Technology (HKUST)</em></strong> hosted the 2022 iGEM Symposium with the theme of <u>&ldquo;Sustainable Living through SynBio&rdquo;</u> on the 13th of August 2022. The Symposium was a one-day event where iGEM teams in Hong Kong came together to present their project idea, research execution, problems and solutions, and human practices events. HKUST had also invited Professor Yong Lai and Professor Fei Sun, two esteemed professors from their university, to be guest speakers at the symposium, where <u>they enlightened us on the advancing field of synthetic biology</u> and the remarkable contributions they made in the research areas of microbiomes and biomaterials field, respectively.</p>
              <p>The event consisted of <strong><em>CityU, HKUST, CUHK, HKU, and HK_CPU-WYY iGEM teams</em></strong>, whom each delivered an engaging presentation that discussed their initial inspiration for tackling such a problem and their approach to executing their proposed solutions. After each presentation, other teams asked questions to gain a better understanding <u>while providing constructive feedback for the betterment of all projects presented. </u></p>
              <p>The <strong><em>CityU SeCure team</em></strong> presented our project on anticancer drug discovery and the theory behind our research, followed by actual results we had obtained by that point and our plans to enhance our current track. The other iGEM teams then asked us questions and indulged us in their observations of our work, along with comments and constructive critiques. <em><u>Their suggestions made us review particular elements of our projects, such as conducting a control test of our fungi to have as a standard before performing fungal transformation and analysing the products formed.</u></em> The feedback session was significantly valuable as we saw what aspects required further elaboration to ensure our explanations were comprehensible.</p>
              <br />
              <br />

              <div className="collabimage">
                <img src="https://static.igem.wiki/teams/4154/wiki/export.png" alt="" />
              </div>
              <br />
              <br />
              <p>HKUST had arranged a mingling session where teams could have in-depth discussions of the features of their project and the constructive feedback received during the Q&amp;A sessions. Our team had the chance to speak to our partner team, CUHK-SBS, in person to learn more about them as a team and as people. This enhanced our partnership as it added an element of friendship to our dynamic. The in-person meeting enriched our meetings from there on as we could discuss matters with more freedom and overall improved the quality of the activities we conducted together.</p>
              <p> We spoke to some of the other iGEM teams as well as their project concepts were fascinating and were related to fields far from anticancer drug discovery. The HKU team developed their project on tackling antibiotic resistance using antimicrobial peptides, and HKUST with their project on developing a biosensor to tackle fish spoilage.</p>
              <p> The entire experience was an adventure worth remembering. So, <em><u>our team created a vlog to record our venture to the HKUST campus</u></em>, listening to the guest speakers and other iGEM teams and delivering our presentation. We ended our trip by interviewing members from each team about their views on the project presentations given, their experience so far participating in iGEM and what made them join in the first place. We learnt more about everyone and generated a friendly bond with each of them, making the symposium a treasurable day.</p>
              <br />
              <br />
              <div className="collabimage">
                <img src="https://static.igem.wiki/teams/4154/wiki/img-1662.jpeg" alt="" />
              </div>
              <br />
              <br />
              
              </section>

            <br />
            <br />
            <br />
            <br />
              {/* <section id="HongKong">
              <p>
                <h3>
                  Hong Kong University of Science and Technology, Hong Kong (13th August)
                </h3>

                The Hong Kong University of Science and Technology (HKUST) hosted the 2022 iGEM Symposium on “Sustainable Living through SynBio” on the 13th of August 2022. The event allowed iGEM teams in Hong Kong - CityU, HKUST, CUHK, HKU, HK_CPU-WYY - to come together and share their project ideas and progress. Each team presented the issue their project is concerned with and the approaches they took to curate a solution as the basis for their iGEM project. HKUST also invited 2 guest speakers to share their research and contributions to the SynBio field.
                <br />
                <br />
                After the presentations, there was a mingling session where we got the opportunity to interact with other team members and have in-depth conversations about our feedback and questions regarding their project for further improvement. The experience was truly momentous and so we directed a vlog of our day at the HKUST Symposium to provide the public insight to what university students are doing in the field of SynBio and the experience of the Symposium. Towards the end of the symposium, we asked a few members from each time to join us for a short interview where we briefly asked about their views on the other iGEM teams and their experience of the journey so far.
                <br />
                <br />
                Overall the Symposium was truly rewarding. Our team got to proudly present our work to the other iGEM teams in Hong Kong and exchanged constructive feedback for the improvement of our project. The talks organised by the guest speakers disclosed the scope of SynBio and its capabilities and truly inspired us to continue work in this field.

              </p>

              </section> */}

            
            <section id="Mexico">
              <p>
                <h3>
                  Chihuahua Institute of Technology, Mexico (15th August)
                </h3>
              </p>

              <ul>
                <li>Collaboration on human practices and education</li>
                <li>Created and sent two comics about &ldquo;What are fungi?&rdquo; and &ldquo;What is PCR?&rdquo; for elementary children to learn about synthetic biology whilst colouring the comics.</li>
              </ul>
              <p><strong><em>The Chihuahua Institute of Technology iGEM team</em></strong> proposed an <u>iGEM Comic book</u>. The concept was to ask iGEM teams worldwide to participate by submitting two comics about their project or a synthetic biology technique they would like to introduce to elementary students. The Tech Chihuahua team then translated the book into two final versions in English and Spanish. They then distributed the comic to elementary students in Mexico to colour and learn about the concepts illustrated by each iGEM team.</p>
              <p>&nbsp;</p>
              <p><em><u>Over 20 teams from all over the world participated in designing these comics, which generated a diverse and creative comic book where various styles and concepts were introduced.</u></em> Our team created two comics, <strong>&ldquo;What are fungi?&rdquo;</strong> to introduce the component that forms the fundamental basis of our project and their versatile usage and benefits, followed by <strong>&ldquo;What is PCR?&rdquo;</strong> as this is one of the most widely employed laboratory techniques in synthetic biology research. The final comic was engaging and allowed us to learn more about the participating iGEM teams.</p>

              <a href="https://drive.google.com/file/d/1Oh3Ykv7VqsJe4FyaVFcqhOU4b2JU_5Lf/view" target="_blank" className="Download"><em>The magic of synthetic biologyAspergillus oryzae</em>  </a>
              <br />
              <br />
              <br />
              
            
            </section>


            <section id="Taiwan">
              <p>
                <h3>
                  National Tsing Hua University, Taiwan (August)
                </h3>
              </p>

              <p><strong><em>We collaborated with the National Tsing Hua University iGEM team,</em></strong> where they developed an <u>iGEM map</u>.</p>
              <p>Teams internationally were asked to create a mascot that they believed represented their project and goals, along with a brief description of their project focus. Our mascot was Dr SeCure, a synthetic biologist we designed to introduce genetic engineering concepts associated with our project, such as the process of developing anticancer drugs from fungi.</p>
              <p><u>The event led to the production of a diverse and interactive map with 31 iGEM teams participating worldwide</u>. It was fascinating to see how the influence of culture and locality varied amongst each team which ultimately prompted what inspired teams to develop their chosen project focus. The map acted as a medium to tie together iGEM teams worldwide and truly conveyed this competition's internationalism.</p>
              <br />
              <br />
              <iframe title="NTHU_Taiwan: iGEM MAP (2022) [English]" width="100%" height="415" src="https://video.igem.org/videos/embed/65ecc202-f666-45b4-a9e8-25f449db1794" frameborder="0" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups"></iframe>

              <br />
              <br />
              <br />
              <iframe title="NTHU_Taiwan: iGEM MAP (2022) [English]" width="100%" height="415" src="https://igem-map-2022-nthu-taiwan.on.drv.tw/iGEM%20Map/map1009.html" frameborder="0" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups"></iframe>

              
              <p><em><u>To view the collaboration</u></em>: <a href="https://2022.igem.wiki/nthu-taiwan/collaborations">https://2022.igem.wiki/nthu-taiwan/collaborations</a></p>

            </section>

            <section id="Indian">
              <h1>
                Indian Institute of Science Education and Research Bhopal, India
              </h1>
              <p>
                We collaborated with the IISER_Bhopal iGEM team where they developed a multilingual dictionary. The goal was to ask members of iGEM teams worldwide to translate technical and complicated scientific terms that are often encountered when working in the field of synthetic biology and genetic engineering.
                <br />

                The selected vocabulary was translated into over 17 languages from iGEM teams internationally. Our team helped translate words to Kyrgyz, Russian, Korean, Traditional Chinese, Korean, and Indonesian. We believe through this activity, we can promote inclusivity and diversity in the field for people of all nationalities and backgrounds. It builds the foundation for a platform where anyone can work and understand this scientific discipline without being at any form of linguistic disadvantage.
                <br />
                Not only does the multilingual dictionary help diverse science students participate in the field, but it also makes explaining the synbio concept to non-English speakers easier as they can find translations for technical terms in their native language.
                <a className="Download" href="https://static.igem.wiki/teams/4154/wiki/assets/multilingual-dictionary-secure-cityu-collab.pdf">Press to see the dictionary</a>
              </p>
            </section>

          </>
        </div>
      </section>
    </div>
  );
}

export default Collaborations;
